<template>
  <el-table-column
    prop="comment"
    label="Megjegyzés"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.comment || '-' }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'comment',
  };
</script>
